import React from 'react';

function Icon() {
  return (
    <svg width="42" height="42" fill="none" viewBox="0 0 42 42">
      <path
        fill="#4783FF"
        d="M34.346 4.173h-13.29V.054h-4.118v10.302h-9.16L.442 18.593l7.336 8.238h9.16v14.42h4.119V20.647h13.29l7.204-8.237-7.205-8.237zM16.938 20.647v2.065H9.624l-3.669-4.119 3.669-4.118h7.314v6.172zm15.53-4.118H21.046V8.29h11.422l3.602 4.119-3.602 4.119z"></path>
    </svg>
  );
}

export default Icon;
